module.exports = __webpack_public_path__ + "img/thumbnail-header-16.2dfaf21.png";